import { CreateCheckoutRequest } from '@scopely/web-sdk-payments';
import { nestApiClient, paymentAPiClient } from '../client/api-client';

export const checkoutPayment = async (
  payload: CreateCheckoutRequest & {
    offerId: string;
  }
) => {
  return await paymentAPiClient.post<{
    data: {
      paymentId: string;
      provider: string;
      message: string;
      success: boolean;
    };
  }>('/v1/payments/checkout', payload);
};
export const cancelPayment = async ({ paymentId }: { paymentId: string }) => {
  return await paymentAPiClient.put<{
    data: { success: boolean };
  }>(`/v1/payments/cancel/${paymentId}`);
};

export const getPurchaseDailyByWebcoin = ({ offerId }: { offerId: string }) => {
  return nestApiClient.post('/offers/v2/webcoin', {
    offerId,
  });
};

export const purchaseAvatarAsync = ({
  price,
  avatarId,
}: {
  price: number;
  avatarId: string;
}) => {
  return nestApiClient.post('/webShop/v2/avatar', { price, avatarId });
};

export const purchaseFrameAsync = ({
  price,
  frameId,
}: {
  price: number;
  frameId: string;
}) => {
  return nestApiClient.post('/webShop/v2/frame', { price, frameId });
};

export const purchaseEnergyPackAsync = ({ name }: { name: string }) => {
  return nestApiClient.post('/webShop/v2/energy', { name });
};

export const claimPayment = ({ paymentId }: { paymentId: string }) => {
  return paymentAPiClient.put<
    unknown,
    {
      data: {
        data: {
          success: boolean;
        };
      };
    }
  >(`/v1/payments/claim/${paymentId}`);
};

export const getUnclaimedPayments = () => {
  return paymentAPiClient.get('/v1/payments/unclaimedPayments');
};

export const purchaseOfferByClubCoin = ({ offerId }: { offerId: string }) => {
  return nestApiClient.post('/club/offers/purchase', {
    offerId,
  });
};

export const getXsollaToken = (payload: {
  sku?: string;
  offerId?: string;
  packageId?: string;
  redirectUri?: string;
  version?: string;
}) => {
  const payloadActual: any = {
    ...payload,
  };
  return nestApiClient.post<{ data: { token: string } }>(
    '/xsolla/v2/token',
    payloadActual
  );
};

export const claimReward = (offerId: string) => {
  return nestApiClient.post<{ data: { transactionId: string } }>(
    '/offers/v2/claim',
    {
      offerId,
    }
  );
};
